import { useState, useContext, useCallback, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Context from "../../storage/context";
import CardCar from "../CarCard/CardCar";
import CarDetails from "../CarDetails/CarDetails";
import '../CarDetails/style.css';

const STORAGE_KEY = "like";

const Cars = () => {
    let ctx = useContext(Context);
    let carsPerPage = 8;
    const [selected, setSelected] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const { carId } = useParams();
    const navigate = useNavigate();
    // const scrollRef = useRef(0);
    const scrollRefNumber = useRef(0);
    const favFiltered = useRef(false);

    useEffect(() => {
        if (window.location.state?.noScroll) return;
        ctx.setSearch({ make: "", year: "", km: "", btn_text: "חפש עכשיו", click: false })
    }, []);

    // Filter favorites once, after the cars list has loaded
    useEffect(() => {
        if (favFiltered.current) return;                           // run only once
        if (!ctx.getAllCars || ctx.getAllCars.length === 0) return; // wait until cars are loaded

        let ifExists = [];
        try {
            ifExists = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; // handle null / missing key
        } catch {
            ifExists = []; // handle corrupted JSON
        }

        // Keep only IDs that still exist in getAllCars
        const filterArrFav = ifExists.filter(id =>
            ctx.getAllCars.some(car => String(car.car_id) === String(id))
        );

        ctx.setArrFavCars(filterArrFav);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(filterArrFav)); // persist the cleaned list
        favFiltered.current = true;
    }, [ctx.getAllCars]);


    let CARS = []
    CARS = ctx.getAllCars.filter(c => c.recommended.toLowerCase() === "yes") || [];

    if (ctx.getSearch.click) {
        if (ctx.getSearch.make === "" && ctx.getSearch.year === "" && ctx.getSearch.km === "") {
            CARS = ctx.getAllCars;

        } else {
            if (ctx.getSearch.make === "") {
                CARS = ctx.getAllCars;

            } else {
                CARS = ctx.getAllCars?.filter(c => c.car_make === ctx.getSearch.make) || [];

            }
            if (ctx.getSearch.year !== "" && CARS.length !== 0) {
                CARS = CARS.filter(c => c.year === ctx.getSearch.year) || [];

            }
            if (ctx.getSearch.km !== "" && CARS.length !== 0) {
                let newArr = [...CARS];
                CARS = [];
                for (let i = 0; i < newArr.length; i++) {
                    const km = Number(newArr[i].km.replaceAll(",", "").trim());
                    switch (ctx.getSearch.km) {
                        case "עד 30,000": if (km <= 30000) CARS.push(newArr[i]); break;
                        case "30,000–60,000": if (km > 30000 && km <= 60000) CARS.push(newArr[i]); break;
                        case "60,000–100,000": if (km > 60000 && km <= 100000) CARS.push(newArr[i]); break;
                        case "100,000+": if (km > 100000) CARS.push(newArr[i]); break;
                    }
                }

            }
        }
    } else if (ctx.getFavCars && ctx.getArrFavCars.length !== 0) {
        CARS = [];
        ctx.getArrFavCars.forEach(car_id => {
            CARS.push(ctx.getAllCars.find(c => c.car_id === car_id))
        })
    }

    const onClickPage = (e) => {
        scrollRefNumber.current = window.scrollY;
        setSelectedPage(parseInt(e.target.innerText));
    }

    const onClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setSelectedPage(1);
        ctx.setSearch({ make: "", year: "", km: "", btn_text: "חפש עכשיו", click: false })
    };
    // const allCars = () => ctx.setSearch({ make: "", year: "", km: "", btn_text: "בטל סינון", click: true });

    const openModal = useCallback(car => {
        setSelected(car);
        document.getElementById("cars-section").scrollIntoView({ behavior: "smooth" });
        navigate(`/cars/${car.car_id}`, { replace: true });
        requestAnimationFrame(() => setOpen(true));
    }, []);

    const closeModal = useCallback(() => {
        setOpen(false);
        window.history.replaceState(null, '', '/searchCar');
        setTimeout(() => setSelected(null), 380);
        document.getElementById("cars-section").scrollIntoView({ behavior: "smooth" });
    }, []);

    const onClickFav = useCallback(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        ctx.setFavCars(false)
    }, [])
    useEffect(() => {
        if (!carId) return;

        const car = ctx.getAllCars.find(car => String(car.car_id) === String(carId));
        if (!car) return;

        setSelected(car);
        requestAnimationFrame(() => setOpen(true));
    }, [carId, ctx.getAllCars]);




    let sliceStart = (selectedPage * carsPerPage) - carsPerPage;
    let sliceEnd = (selectedPage * carsPerPage);
    return (
        <section className="section cars-section" id="cars-section">
            <div className="section-inner">
                {!ctx.getSearch.click ? (
                    <>
                        <div className="cars-header">
                            <div>
                                <div className="section-tag">מלאי נבחר</div>
                                <h2 className="section-title">רכבים מומלצים</h2>
                                <p className="section-sub" style={{ marginBottom: 0 }}>נבחרו בקפידה מתוך מאות רכבים</p>
                            </div>
                            {ctx.getFavCars && <button className="btn-ghost" onClick={onClickFav}>בטל סינון ←</button>}
                        </div>
                        <div className="cars-grid">
                            {CARS.map(car => (
                                <CardCar key={car.car_id} data={car} onDetails={openModal} />
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        <div className="cars-header">
                            <div>
                                <div className="section-tag" ref={scrollRefNumber}>{ctx.getSearch.make !== "" ? ctx.getSearch.make : "כל היצרנים"}</div>
                                <p className="section-sub" style={{ marginBottom: 0 }}>
                                    {`${ctx.getSearch.year !== "" ? ctx.getSearch.year : "כל השנים"} -> ${ctx.getSearch.km !== "" ? ctx.getSearch.km : "כל הטווחים"}`}
                                </p>
                            </div>
                            <button className="btn-ghost" onClick={onClick}>בטל סינון ←</button>
                        </div>
                        <div className="cars-grid">
                            {CARS.length !== 0
                                ? CARS.slice(sliceStart, sliceEnd).map(car => <CardCar key={car.car_id} data={car} onDetails={openModal} />)
                                : <div>לא נמצאו רכבים</div>
                            }
                        </div>
                        <div className="cars-footer">

                            <div className="pages-tag">
                                {
                                    Array.from(
                                        { length: Math.ceil(CARS.length / carsPerPage) },
                                        (_, i) => (
                                            <span key={i} id={`page-${i + 1}`} className={`page-number ${selectedPage === (i + 1) ? 'active' : ''}`} onClick={onClickPage}>
                                                {i + 1}
                                            </span>
                                        )
                                    )
                                }
                            </div>


                        </div>
                    </>
                )}
            </div>
            {selected && <CarDetails car={selected} open={open} onClose={closeModal} />}
        </section>
    );
};

export default Cars;